import {
  Overlay,
  ModalContainer,
  ModalHeader,
  Title,
  CloseButton,
  Table,
  Th,
  Td,
} from "./styles";

const LogsModal = ({ show, onClose, merges }) => {
  if (!show) return null;

  return (
    <Overlay>
      <ModalContainer>
        <ModalHeader>
          <Title>Histórico de Merges</Title>
          <CloseButton onClick={onClose}>Fechar</CloseButton>
        </ModalHeader>

        {merges.length === 0 ? (
          <p>Nenhum merge encontrado.</p>
        ) : (
          <Table>
            <thead>
              <tr>
                <Th>Usuário Upload</Th>
                <Th>Data Upload</Th>
                <Th>Usuário Cancelamento</Th>
                <Th>Data Cancelamento</Th>
                <Th>Motivo Cancelamento</Th>
                <Th>Cancelado</Th>
              </tr>
            </thead>
            <tbody>
              {merges.map((merge) => (
                <tr key={merge.id}>
                  <Td>{merge.usuario_upload.full_name || merge.usuario_upload.email}</Td>
                  <Td>{new Date(merge.data_merge).toLocaleString()}</Td>
                  <Td>
                    {merge.usuario_cancelamento
                      ? merge.usuario_cancelamento.full_name || merge.usuario_cancelamento.email
                      : "-"}
                  </Td>
                  <Td>
                    {merge.data_cancelamento
                      ? new Date(merge.data_cancelamento).toLocaleString()
                      : "-"}
                  </Td>
                  <Td>{merge.motivo_cancelamento || "-"}</Td>
                  <Td>{merge.is_cancelado ? "Sim" : "Não"}</Td>
                </tr>
              ))}
            </tbody>
          </Table>
        )}
      </ModalContainer>
    </Overlay>
  );
};

export default LogsModal;
